import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { supabase } from '../utils/supabase';
import ClubTournamentList from '../components/tournaments/ClubTournamentList';

const TournamentsPage = ({ currentUser }) => {
  const { clubId } = useParams();
  const [canManageTournaments, setCanManageTournaments] = useState(false);

  useEffect(() => {
    if (!currentUser?.id || !clubId) {
      setCanManageTournaments(false);
      return;
    }
    let cancelled = false;
    (async () => {
      const { data, error } = await supabase
        .from('players_club')
        .select('club_role')
        .eq('club_id', clubId)
        .eq('player_id', currentUser.id)
        .eq('is_active', true)
        .maybeSingle();

      if (cancelled) return;
      if (error || !data) {
        setCanManageTournaments(false);
        return;
      }
      setCanManageTournaments(['owner', 'admin', 'host'].includes(data.club_role));
    })();
    return () => {
      cancelled = true;
    };
  }, [currentUser?.id, clubId]);

  if (!clubId) return null;

  return (
    <ClubTournamentList
      clubId={clubId}
      canManageTournaments={canManageTournaments}
      seasonId={null}
      layout="page"
    />
  );
};

export default TournamentsPage;
